import {
  Button,
  DatePicker,
  Drawer,
  Input,
  Select,
  Space,
  Typography,
} from 'antd';
import CustomSelect from '../../common/Select/Select';
import { initFilters } from './AuditLog';
import { useEffect, useState } from 'react';
import { getCommonSearch } from '../../../services/commonAPI';
import { dateRange } from '../../../utils/helpers/helper';

const dateOptions = [
  {
    label: 'Today',
    value: 'Today',
  },
  {
    label: 'Yesterday',
    value: 'Yesterday',
  },
  {
    label: 'Last 7 days',
    value: 'Last 7 days',
  },
  {
    label: 'Last 30 days',
    value: 'Last 30 days',
  },
  {
    label: 'This month',
    value: 'This month',
  },
  {
    label: 'Last month',
    value: 'Last month',
  },
  {
    label: 'Custom',
    value: 'Custom',
  },
];

export default function FiltersPane({
  openFilters,
  type,
  setOpenFilters,
  filterValues,
  setFilterValues,
  handleApply,
}) {
  const { Text } = Typography;
  let currentValue = {
    modifiedby: '',
  };

  const [options, setOptions] = useState({
    modifiedby: [],
    idList: [],
  });
  const [error, setError] = useState({
    modifiedby: '',
    idList: '',
  });
  const [loader, setLoader] = useState({
    modifiedby: false,
    idList: false,
  });

  let api = {
    email: '/modifiedby',
    transactions: '/transactions/search',
    invoices: '/invoices/search',
    payouts: '/payouts/search',
  };

  useEffect(() => {
    setOptions({ ...options, idList: [] });
    setError({ ...error, idList: '' });
  }, [type]);

  const fieldOptions = {
    transactions: [
      { value: 'transaction_created', label: 'Transaction Created' },
      { value: 'payRate', label: 'Pay Rate' },
      { value: 'hours', label: 'Hours' },
      { value: 'unit', label: 'Unit' },
      { value: 'amount', label: 'Amount' },
      { value: 'transaction_status', label: 'Transaction Status' },
      { value: 'notes', label: 'Notes' },
    ],
    invoices: [
      { value: 'invoice_created', label: 'Invoice Creation' },
      { value: 'invoice_status', label: 'Invoice Status' },
      { value: 'payout_status', label: 'Payout Status' },
      { value: 'notes', label: 'Notes' },
    ],
    payouts: [
      { value: 'payout_created', label: 'Payout Creation' },
      { value: 'payout_rail', label: 'Payout Rail' },
      { value: 'completed_date', label: 'Completed Date' },
      { value: 'status', label: 'Payout Status' },
      { value: 'attempt', label: 'Attempt' },
      { value: 'reattempt_status', label: 'Reattempt Status' },
      { value: 'notes', label: 'Notes' },
      { value: 'failure_notes', label: 'Failure Reason' },
    ],
  };

  const handleFieldValues = () => {
    return [...fieldOptions[type]];
  };
  // List of filters
  const filters = [
    {
      name: 'Type',
      key: 'type',
      type: 'select',
      mode: 'selected',
      disabled: true,
      defaultValue: type,
      placeholder: 'Select Type',
      options: [
        {
          key: 'transactions',
          value: 'Transaction',
        },
        {
          key: 'invoices',
          value: 'Invoice',
        },
        {
          key: 'payouts',
          value: 'Payout',
        },
      ],
    },
    {
      name: `Select ID`,
      key: 'idList',
      mode: 'multiple',
      type: 'api',
      value: filterValues['idList'] || '',
      placeholder: 'Enter Id',
      info: 'Enter 3 letters for dropdown',
    },
    {
      name: 'Field',
      key: 'fieldChanged',
      type: 'select',
      mode: 'multiple',
      placeholder: 'Select Field',
      options: handleFieldValues(),
      info: 'please selecct type to display the options',
    },
    {
      name: 'Date Modified',
      key: 'fixedRangeForCreated',
      type: 'custom',
      renderer: () => (
        <div
          style={{
            width: '100%',
            gap: 16,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Select
            style={{ width: '100%' }}
            onChange={(e) =>
              handleFilterChange(e, 'select', 'fixedRangeForCreated')
            }
            options={dateOptions}
            placeholder="Select Range"
            value={filterValues['fixedRangeForCreated']}
          />
          {filterValues.fixedRangeForCreated === 'Custom' && (
            <DatePicker.RangePicker
              defaultValue={
                (filterValues['fixedRangeForCreated.customDates'] &&
                  dateRange(
                    filterValues['fixedRangeForCreated.customDates'],
                  )) ||
                ''
              }
              onChange={(_v, dates) =>
                handleFilterChange(
                  dates,
                  'date_range',
                  'fixedRangeForCreated.customDates',
                )
              }
            />
          )}
        </div>
      ),
    },
    {
      name: 'Modified By',
      key: 'modifiedBy',
      type: 'text',
      mode: 'multiple',
      value: filterValues['modifiedBy'] || '',
      placeholder: 'Enter email address',
      //info: 'please enter 3 letters to search',
    },
  ];

  const handleReset = () => {
    setFilterValues(initFilters);
  };

  const handleFilterChange = (v, _type, key) => {
    setFilterValues({
      ...filterValues,
      [key]: v,
    });
  };

  const handleFilterSearch = (v, _type, key) => {
    currentValue[key] = v;
    if (v.length > 2) {
      setLoader({ ...loader, [key]: true });
      getCommonSearch({ searchTerm: v }, api[type])
        .then((res) => {
          if (currentValue[key] === v) {
            const data = res.map((ele) => ({
              key: ele,
              value: ele,
            }));
            if (data.length === 0) {
              setError({ ...error, [key]: `No data found with ${v}` });
            }
            setOptions({ ...options, [key]: data });
          }
        })
        .catch(() => {
          setError({ ...error, [key]: `Unable to fetch ${key}` });
        })
        .finally(() => {
          setLoader({ ...loader, [key]: false });
        });
    } else {
      setError({ ...error, [key]: '' });
    }
  };

  return (
    <Drawer
      title={`Filters`}
      placement="right"
      size={400}
      onClose={() => setOpenFilters(false)}
      open={openFilters}
      extra={
        <Space>
          <Button onClick={() => handleReset()}>Reset</Button>
          <Button type="primary" onClick={() => handleApply()}>
            Apply
          </Button>
        </Space>
      }
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: '18px' }}>
        {filters.map((filter) => {
          return (
            <div key={filter.name} style={{ display: 'block' }}>
              <Text key={filter.name} style={{ fontSize: '16px' }}>
                {filter.name}
              </Text>
              {filter.type === 'text' ? (
                <Input
                  key={filter.name}
                  placeholder={filter.name}
                  defaultValue={filter.defaultValue}
                  value={filterValues[filter.key] || filter.defaultValue}
                  onChange={(e) =>
                    handleFilterChange(e.target.value, 'text', filter.key)
                  }
                />
              ) : filter.type == 'select' ? (
                <CustomSelect
                  mode={filter.mode}
                  key={filter.name}
                  disabled={filter.disabled}
                  options={filter.options || []}
                  notFoundContent={filter.info}
                  defaultValue={filterValues[filter.key] || filter.defaultValue}
                  placeholder={filter.placeholder || filter.name}
                  value={filterValues[filter.key] || filter.defaultValue}
                  onChange={(e) => handleFilterChange(e, 'select', filter.key)}
                />
              ) : filter.type == 'api' ? (
                <CustomSelect
                  loading={loader[filter.key]}
                  mode={filter.mode}
                  key={filter.name}
                  disabled={filter.disabled}
                  notFoundContent={error[filter.key] || filter.info}
                  options={options[filter.key] || []}
                  defaultValue={filterValues[filter.key] || filter.defaultValue}
                  placeholder={filter.placeholder}
                  value={filterValues[filter.key] || filter.defaultValue}
                  onSearch={(e) => handleFilterSearch(e, 'select', filter.key)}
                  onChange={(e) => handleFilterChange(e, 'select', filter.key)}
                />
              ) : filter.type == 'custom' ? (
                filter.renderer()
              ) : null}
            </div>
          );
        })}
      </div>
    </Drawer>
  );
}
